import React, { useState, useRef } from "react";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import Care from "./Care";
import { fetchRandomQuote } from "./service/quotesApi";
import SEO from "../components/SEO";

export default function Packages() {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const toastRef = useRef(null);
  const [currentQuote, setCurrentQuote] = useState("Loading quote...");
  // Array of face services
  const Packages = [
    {
      id: 21,
      name: "Full Legs + Hands + Underarms",
      price: "6,999",
      originalPrice: "8,979",
      duration: "2 Hrs",
    },
    {
      id: 22,
      name: "Full Legs + Underarms + Bikini",
      price: "6,999",
      originalPrice: "8,400",
      duration: "1 Hr 45 Min",
    },
    {
      id: 23,
      name: "Full Face + Underarms",
      price: "3,499",
      originalPrice: "3,898",
      duration: "1 Hr",
    },
    {
      id: 24,
      name: "Bikini + Buttocks",
      price: "4,499",
      originalPrice: "5,998 ",
      duration: "1 Hr 30 Min",
    },
    {
      id: 25,
      name: "Full Face + Bikini",
      price: "4,999",
      originalPrice: "5,899",
      duration: "1 Hr 30 Min",
    },
    {
      id: 26,
      name: "Full Front + Full Back",
      price: "5,499",
      originalPrice: "5,999",
      duration: "1 Hr 30 Min",
    },
    {
      id: 27,
      name: "Full Hands + Underarms",
      price: "3,499",
      originalPrice: "4,000",
      duration: "1 Hr 30 Min",
    },
    {
      id: 28,
      name: "Full Hands + Full Legs",
      price: "6,499",
      originalPrice: "7,499",
      duration: "1 Hr 30 Min",
    },
  ];
  const handleAddToCart = async (service) => {
    addToCart(service);
    try {
      // Fetch new quote
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }

    // Show the toast
    const toast = new window.bootstrap.Toast(toastRef.current);
    toast.show();
  };
  const handleBuyNow = async (service) => {
    // Add to cart first
    addToCart(service);

    try {
      // Fetch new quote
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }

    // Navigate to checkout page
    navigate("/checkout");
  };

  return (
    <div
      className=" min-vh-100"
      style={{ fontFamily: "'Inter', sans-serif", backgroundColor: "#8dcae4" }}
    >
      <SEO
        title="Laser Hair Removal Combo Packages | FlawSkin"
        description="Explore FlawSkin's laser hair removal combo packages for smooth, hair-free skin. Choose from affordable combinations for legs, hands, underarms, bikini, face, and more."
        canonical="https://flawskin.com/packages"
      />
      <Navbar />
      <main className="container py-5">
        <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-3">
          <div className="row align-items-center g-4">
            <div className="col-auto d-none d-sm-block">
              <div className="p-3 bg-primary-subtle rounded-4 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="black"
                  class="bi bi-box-seam me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z"></path>
                </svg>
              </div>
            </div>
            <div className="col">
              <h1 className="h3 fw-bold text-dark mb-2">Combo packages</h1>
              <p
                className="text-secondary mb-0 border-start border-3 ps-3 py-1"
                style={{ fontSize: "15px", maxWidth: "700px" }}
              >
                Get smooth, hair-free skin with our safe and effective laser
                hair removal treatments.
              </p>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row">
          {Packages.map((service) => (
            <div className="col-md-6 mb-4" key={service.id}>
              <div className="card border-light-subtle shadow-sm rounded-3 bg-white p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  {/* Top Heading Group */}
                  <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
                    <h3 className="h6 fw-bold text-dark mb-0 mt-1">
                      {service.name}
                    </h3>
                    <div className="flex-shrink-0">
                      {service.image && (
                        <img
                          src={service.image}
                          className="rounded-3 border border-light-subtle object-fit-cover"
                          alt={service.name}
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "20px",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* Trust Badge Rating */}
                  <div className="d-flex align-items-center gap-2 mb-3 small">
                    <div className="text-warning">
                      <i className="fa fa-star me-1"></i>
                      <span className="fw-bold text-dark">5.0</span>
                    </div>
                    <a
                      href="https://www.google.com/search?hl=en-IN&amp;gl=in&amp;q=Flawskin+pvt+Ltd..."
                      className="text-muted text-decoration-none border-start ps-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      (234 Verified Reviews)
                    </a>
                  </div>

                  {/* Core Timing Specs */}
                  <div className="d-flex align-items-center gap-2 mb-4 text-secondary small bg-light p-2 rounded-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-clock text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.433l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                    </svg>
                    <span>
                      Est. Treatment Window: <strong>{service.duration}</strong>{" "}
                      per session
                    </span>
                  </div>
                </div>

                {/* Pricing & Checkout Block */}
                <div className="mt-auto pt-3 border-top border-light-subtle">
                  <div className="d-flex align-items-baseline justify-content-between mb-3">
                    <span className="text-muted small">Package Price</span>
                    <div className="text-end">
                      <del className="text-muted small me-2">
                        ₹{service.originalPrice}
                      </del>
                      <span className="h4 fw-bold text-primary mb-0">
                        ₹{service.price}
                      </span>
                    </div>
                  </div>

                  {/* Utility Support Modals Links */}
                  <div className="mb-3">
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      className="text-decoration-none small text-secondary d-inline-flex align-items-center gap-1 bg-light px-2.5 py-1 rounded-2 border"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-journal-medical text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5"
                        />
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                      </svg>
                      Pre & Post Care Directive
                    </a>
                  </div>

                  {/* Primary CTA Elements */}
                  <div className="row g-2">
                    <div className="col-6">
                      <button
                        className="btn btn-outline-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small"
                        style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                        onClick={() => handleAddToCart(service)}
                      >
                        Add to Cart
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn btn-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small shadow-sm"
                        style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                        onClick={() => handleBuyNow(service)}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
      <Care />
      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div
          ref={toastRef}
          className="toast"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          data-bs-autohide="true"
          data-bs-delay="3000"
        >
          <div className="toast-body">
            <div className="d-flex gap-4">
              <span>
                <i className="fa-solid fa-circle-check fa-lg text-success"></i>
              </span>
              <div className="d-flex flex-column flex-grow-1 gap-2">
                <div className="d-flex align-items-center">
                  <span className="fw-semibold">Item added to cart!</span>
                  <button
                    type="button"
                    className="btn-close btn-close-sm ms-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <p className="mb-0 small text-muted fst-italic">
                  {currentQuote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
